if(typeof {} === 'undefined') {var e = new Error("Cannot find module '{}'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = {};